import { createSelector } from 'reselect';
import _pick from 'lodash/pick';

import { multiSelect } from 'react-redux-app/lib/modules/form/utils';

import { getCampaigns } from './campaigns';


const getCampaignIdsSortedByName = state => state.campaign.idsSortedByName;

export const getCampaignNames = createSelector(
  getCampaigns,
  getCampaignIdsSortedByName,
  (campaigns, campaignIds) => (campaignIds.length === 0
    ? []
    : campaignIds.map(campaignId => _pick(campaigns[campaignId], ['id', 'name']))
  )
);

export const getCampaignNameOptions = createSelector(
  getCampaignNames,
  campaignNames => campaignNames.map(({ id, name }) => multiSelect.createOption(name, id))
);

export const getCampaignNameOptionsWithEmpty = state => (
  [multiSelect.createOption('', null)].concat(getCampaignNameOptions(state))
);

export const getIsCampaignNamesLoading = state => state.campaign.isNamesListLoading;

export const getLoadCampaignNamesError = state => state.campaign.errors.loadCampaignNamesError;
